if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      shippingProps = (() => {
        const node = this.querySelector('[data-cf-shipping-data]') || document.getElementById('shipping-data');
        if (!node) return {};
        try { return JSON.parse(node.textContent) || {}; }
        catch (error) { console.warn('Product shipping settings could not be read.', error); return {}; }
      })();
      shippingCalculationElement = this.querySelector('shipping-calc');
      shippingTitle = this.shippingCalculationElement?.querySelector('.shipping-calc__title');
      shippingInnerBlock = this.shippingCalculationElement?.querySelector('.shipping-calc__inner');
      shippingResetButton = this.shippingTitle?.querySelector('button');
      shippingForm = this.shippingCalculationElement?.querySelector('form');
      shippingFormInput = this.shippingForm?.querySelector('input');
      zipRegex = /^\d{5}(-\d{4})?$/;
      shippingFormButton = this.shippingForm?.querySelector('button');
      shippingFormValidationText = this.shippingForm?.querySelector('.zip-form__validation-message');

      variantLabels = this.querySelectorAll('variant-selects .form__label');
      popupBlock = document.querySelector('.popup');
      popupBlockInner = this.popupBlock?.querySelector('.popup__inner');
      closePopupButtons = document.querySelectorAll('.popup__close');

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        document.addEventListener('rebuy:cart.ready', (event) => {

          if (this.shippingCalculationElement && this.shippingForm && this.shippingFormInput &&
              this.shippingFormButton && this.shippingFormValidationText && this.shippingResetButton &&
              this.shippingInnerBlock && !this.cfShippingBound) {
            this.cfShippingBound = true;

            this.shippingFormInput.addEventListener('input', () => {
              const sanitizedValue = this.shippingFormInput.value.replace(/[^0-9-]/g, '');

              this.shippingFormInput.value = sanitizedValue;
              const isValid = this.zipRegex.test(sanitizedValue);

              this.shippingFormValidationText.innerHTML = this.shippingProps.error_zip_on_type;

              if (isValid) {
                this.shippingFormButton.disabled = false;
                this.shippingFormValidationText.style.display = 'none';
              } else {
                this.shippingFormButton.disabled = true;
                this.shippingFormValidationText.style.display = 'block';
              }
            });

            this.shippingForm.addEventListener('submit', (e) => {
              e.preventDefault();
              if (variantId && this.shippingFormInput?.value.trim() && window.Rebuy?.Cart) {
                this.calculateShipping(this.productForm?.variantIdInput?.value - 0);
              }
            });

            this.shippingResetButton.addEventListener('click', (e) => {
              this.shippingReset();
            })

            this.shoppingPopup();
          }
        });


        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));

        this.toggleActiveClassOnClick(this.variantLabels);

        this.waitForElm('.jdgm-qa-badge').then((qaTrigger) => {
          const starsTrigger = document.querySelector('.jdgm-prev-badge__stars');
          const reviewTab = document.querySelector('[data-app-title-reviews]');
          const questionTab = document.querySelector('[data-app-title-question]');
          qaTrigger.addEventListener('click', (e) => {
            questionTab?.click();
          });
          starsTrigger?.addEventListener('click', (e) => {
            reviewTab?.click();
          });
        });
      }

      shoppingPopup() {

        this.addEventListener('click', (e) => {
          if (e.target.closest('[popup-trigger]')) {
            const curId = e.target.closest('[popup-trigger]').getAttribute('popup-trigger');
            const popupBlock = document.getElementById(curId);
            if (!popupBlock) return;
            document.documentElement.classList.add('overflow');
            popupBlock.classList.add('active');
          }
        });

        this.closePopupButtons.forEach(btn => {
          btn.addEventListener('click', () => {
            document.documentElement.classList.remove('overflow');
            btn.closest('.popup').classList.remove('active');
          });
        });

        document.addEventListener('click', (e) => {
          const popupBlock = document.querySelector('.popup.active');
          if (popupBlock) {
            const inner = popupBlock.querySelector('.popup__inner');
            if (e.target === inner) {
              document.documentElement.classList.remove('overflow');
              popupBlock.classList.remove('active');
            }
          }
        });
      }

      async calculateShipping(currentVariantId) {
        try {
          const currentVariantQuantity = this.quantityInput.value - 0;

          const Cart = window.Rebuy.Cart;
          const cart = Cart.getCart();
          const cartItemsCount = cart.item_count;

          const zipCode = this.shippingFormInput.value;

          fetch(`https://api.zippopotam.us/us/${this.shippingFormInput.value}`)
            .then((response) => {
              if (!response.ok) {
                throw new Error("Network response was not ok");
              }
              return response.json();
            })
            .then((dataRegion) => {
              document.querySelector("body").classList.add("hide-rebuy-drawer");

              this.shippingCalculationElement.classList.add('active');
              this.shippingTitle.querySelector('span').innerHTML = zipCode;

              this.shippingInnerBlock.innerHTML = "";
              this.shippingInnerBlock.insertAdjacentHTML('beforeend', '<div class="preloader"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3" opacity="1"><animate id="spinner_qYjJ" begin="0;spinner_t4KZ.end-0.25s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle><circle cx="12" cy="12" r="3" opacity=".4"><animate begin="spinner_qYjJ.begin+0.15s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle><circle cx="20" cy="12" r="3" opacity=".3"><animate id="spinner_t4KZ" begin="spinner_qYjJ.begin+0.3s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"/></circle></svg></div>');


              if (cartItemsCount === 0) {
                Cart.addItem(
                  {
                    id: currentVariantId,
                    quantity: currentVariantQuantity,
                  },
                  {
                    success: () => {
                      fetch(
                        `https://www.canalesfurniture.com/cart/shipping_rates.json?shipping_address[zip]=${this.shippingFormInput.value}&shipping_address[country]=US&shipping_address[province]=${dataRegion.places[0]["state abbreviation"]}`
                      )
                        .then((response) => {
                          if (!response.ok) {
                            throw new Error("Network response was not ok");
                          }
                          return response.json();
                        })
                        .then((shippingRates) => {
                          this.shippingInnerBlock.innerHTML = "";

                          const localDeliveryRates = shippingRates.shipping_rates.filter(rate =>
                            rate.name.includes("Local Delivery")
                          );

                          if (localDeliveryRates.length > 0) {
                            const minPrice = Math.min(
                              ...localDeliveryRates.map((rate) => parseFloat(rate.price))
                            );

                            const formattedTitle = this.shippingProps.local_delivery_title.trim().toLowerCase().replace(/\+/g, '').replace(/\s+/g, '');

                            const boxItem = `
                              <div popup-trigger="${formattedTitle}" class="shipping-calc__item">
                                <span class="shipping-calc__item-media">
                                  <img src="${this.shippingProps.local_delivery_icon}" alt="${this.shippingProps.local_delivery_link}">
                                </span>
                                <span class="shipping-calc__item-info">
                                  <span class="shipping-calc__item-title">
                                    ${this.shippingProps.local_delivery_title}
                                    <i>${this.shippingProps.link_title}</i>
                                  </span>
                                  <span class="shipping-calc__item-desc">
                                    ${this.shippingProps.price_at}${minPrice}
                                  </span>
                                </span>
                              </div>
                              `;


                            let tempElement = document.createElement('div');
                            tempElement.innerHTML = boxItem;
                            this.shippingInnerBlock.appendChild(tempElement.firstElementChild);

                            // this.shippingInnerBlock.insertAdjacentHTML('beforeend', boxItem);
                          }

                          const nationwideDeliveryRates = shippingRates.shipping_rates.filter(rate =>
                            rate.name.includes("Local Delivery + Assembly")
                          );

                          if (nationwideDeliveryRates.length > 0) {
                            const minPrice = Math.min(
                              ...nationwideDeliveryRates.map((rate) => parseFloat(rate.price))
                            );

                            const formattedTitle = this.shippingProps.nationwide_delivery_title.trim().toLowerCase().replace(/\+/g, '').replace(/\s+/g, '');

                            const boxItem = `
                              <div popup-trigger="${formattedTitle}" class="shipping-calc__item">
                                <span class="shipping-calc__item-media">
                                  <img src="${this.shippingProps.national_delivery_icon}" alt="${this.shippingProps.nationwide_delivery_title}">
                                </span>
                                <span class="shipping-calc__item-info">
                                  <span class="shipping-calc__item-title">
                                    ${this.shippingProps.nationwide_delivery_title}
                                     <i>${this.shippingProps.link_title}</i>
                                  </span>
                                  <span class="shipping-calc__item-desc">
                                  ${this.shippingProps.price_at}${minPrice}
                                  </span>
                                </span>
                              </div>
                              `;

                            let tempElement = document.createElement('div');
                            tempElement.innerHTML = boxItem;
                            this.shippingInnerBlock.appendChild(tempElement.firstElementChild);
                          }


                          Cart.clearCart(); 

                          setTimeout(() => {
                            document.body.classList.remove("hide-rebuy-drawer", "rebuy-cart-visible");
                          }, 900);

                        })
                        .catch((error) => {
                          console.error("There was a problem with the fetch operation:", error);
                        });
                    },
                    error: (error) => {
                      console.error("Error: ", error);
                    },
                  }
                );

              } else {

                const productsObj = cart.items.map((item) => ({
                  id: item.id,
                  quantity: item.quantity,
                }));

                Cart.clearCart();
                Cart.addItem(
                  {
                    id: currentVariantId,
                    quantity: currentVariantQuantity,
                  },
                  {
                    success: () => {
                      fetch(
                        `https://www.canalesfurniture.com/cart/shipping_rates.json?shipping_address[zip]=${this.shippingFormInput.value}&shipping_address[country]=US&shipping_address[province]=${dataRegion.places[0]["state abbreviation"]}`
                      )
                        .then((response) => {
                          if (!response.ok) {
                            throw new Error("Network response was not ok");
                          }
                          return response.json();
                        })
                        .then((shippingRates) => {
                          this.shippingInnerBlock.innerHTML = "";

                          const localDeliveryRates = shippingRates.shipping_rates.filter(rate =>
                            rate.name.includes("Local Delivery")
                          );

                          if (localDeliveryRates.length > 0) {
                            const minPrice = Math.min(
                              ...localDeliveryRates.map((rate) => parseFloat(rate.price))
                            );

                            const formattedTitle = this.shippingProps.local_delivery_title.trim().toLowerCase().replace(/\+/g, '').replace(/\s+/g, '');

                            const boxItem = `
                              <div popup-trigger="${formattedTitle}" class="shipping-calc__item">
                              <span class="shipping-calc__item-media">
                                <img src="${this.shippingProps.local_delivery_icon}" alt="${this.shippingProps.local_delivery_link}">
                              </span>

                              <span class="shipping-calc__item-info">
                                <span class="shipping-calc__item-title">
                                  ${this.shippingProps.local_delivery_title}
                                  <i>${this.shippingProps.link_title}</i>
                                </span>

                                <span class="shipping-calc__item-desc">
                                  ${this.shippingProps.price_at}${minPrice}
                                </span>

                              </span>
                            </div>
                            `;


                            let tempElement = document.createElement('div');
                            tempElement.innerHTML = boxItem;
                            this.shippingInnerBlock.appendChild(tempElement.firstElementChild);
                            // this.shippingInnerBlock.insertAdjacentHTML('beforeend', boxItem);
                          }

                          const nationwideDeliveryRates = shippingRates.shipping_rates.filter(rate =>
                            rate.name.includes("Local Delivery + Assembly")
                          );

                          if (nationwideDeliveryRates.length > 0) {
                            const minPrice = Math.min(
                              ...nationwideDeliveryRates.map((rate) => parseFloat(rate.price))
                            );

                            const formattedTitle = this.shippingProps.nationwide_delivery_title.trim().toLowerCase().replace(/\+/g, '').replace(/\s+/g, '');

                            const boxItem = `
                              <div popup-trigger="${formattedTitle}" class="shipping-calc__item">
                                <span class="shipping-calc__item-media">
                                  <img src="${this.shippingProps.national_delivery_icon}" alt="${this.shippingProps.nationwide_delivery_title}">
                                </span>
                                <span class="shipping-calc__item-info">
                                  <span class="shipping-calc__item-title">
                                    ${this.shippingProps.nationwide_delivery_title}
                                     <i>${this.shippingProps.link_title}</i>
                                  </span>
                                  <span class="shipping-calc__item-desc">
                                  ${this.shippingProps.price_at}${minPrice}
                                  </span>
                                </span>
                              </div>
                              `;

                            let tempElement = document.createElement('div');
                            tempElement.innerHTML = boxItem;
                            this.shippingInnerBlock.appendChild(tempElement.firstElementChild);

                            // this.shippingInnerBlock.insertAdjacentHTML('afterend', boxItem);
                          }


                          Cart.clearCart();

                          Promise.all(
                            productsObj.map((item) =>
                              new Promise((resolve, reject) => {
                                Cart.addItem(
                                  {
                                    id: item.id,
                                    quantity: item.quantity,
                                  },
                                  {
                                    success: resolve,
                                    error: reject,
                                  }
                                );
                              })
                            )
                          )
                            .then(() => {
                              setTimeout(() => {
                                document.body.classList.remove("hide-rebuy-drawer", "rebuy-cart-visible");
                              }, 500);
                            })
                            .catch((error) => {
                              console.error("Error re-adding items to the cart:", error);
                            });
                        })
                        .catch((error) => {
                          console.error("There was a problem with the fetch operation:", error);
                        });
                    },
                    error: (error) => {
                      console.error("Error:", error);
                    },
                  }
                );

              }

            })
            .catch((error) => {
              this.shippingFormValidationText.innerHTML = this.shippingProps.error_zip_code;
              this.shippingFormValidationText.style.display = "block";
              console.error("There was a problem with the fetch operation:", error);
            });
        } catch (error) {
          console.error("Error fetching cart:", error);
        }
      }

      shippingReset() {
        this.shippingInnerBlock.innerHTML = "";
        this.shippingTitle.querySelector('span').innerHTML = "";
        this.shippingForm.reset();
        this.shippingCalculationElement.classList.remove('active');
      }

      arrayChecker(arr, prod) {
        return arr.some(item => item.id !== parseInt(prod, 10));
      }

      waitForElm(selector) {
        return new Promise(resolve => {
          if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
          }

          const observer = new MutationObserver(mutations => {
            if (document.querySelector(selector)) {
              resolve(document.querySelector(selector));
              observer.disconnect();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });
        });
      }

      toggleActiveClassOnClick(elements) {
        const headers = Array.from(elements).filter(element => !element.closest('[data-cf-inline-variants]'));
        headers.forEach((element, index) => {
          if (element.dataset.cfVariantToggleBound) return;
          element.dataset.cfVariantToggleBound = 'true';
          if (index === 0) element.classList.add('active');
          element.addEventListener('click', () => element.classList.toggle('active'));
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber?.();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: (html) => {
            if (shouldSwapProduct) {
              this.handleSwapProduct(productUrl, shouldFetchFullPage)(html);
            } else {
              this.handleUpdateProductInfo(productUrl)(html);
            }
            const labels = this.querySelectorAll('variant-selects .form__label');
            this.toggleActiveClassOnClick(labels);
          },
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        if (variantId && this.shippingFormInput?.value.trim() && window.Rebuy?.Cart) {
          this.calculateShipping(variantId);
        }

        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          if (!input) return;
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;

        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}§ion_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}